export default "__VITE_ASSET__DhKktyhk__"